import { useState } from "react";

export default function SubNavWithPagesHOC(
  SubNav,
  PagesList,
  NoSearchResultContainer,
  ResultsContainer,
  subNavMasonryContainerData
) {
  const WrappedComponent = () => {
    const { subNavData, noSearchResultData, pagesListData, allPagesList } =
      subNavMasonryContainerData;

    const [searchResults, setSearchResults] = useState("");
    const [noSearchResults, setNoSearchResults] = useState(false);
    const [showDefaultContainer, setShowDefaultContainer] = useState(true);
    const [selectedTab, setSelectedTab] = useState(subNavData.defaultActiveTab);

    const handleTabChange = (tab) => {
      setSelectedTab(tab);
    };

    const handleSearch = (searchTerm) => {
      if (searchTerm.length == 0) {
        setSearchResults("");
        setNoSearchResults(false);
        setShowDefaultContainer(true);
      } else {
        const filteredPages = allPagesList.filter((page) => {
          const page_name = page.page_name || page.heading || page.cardHeading;
          let page_title = "";
          let page_description = "";
          if (page.page_title || page.page_description) {
            page_title = page.page_title || "";
            page_description = page.page_description || "";
          }

          let searchTermRegex = new RegExp(searchTerm, "i");
          return (
            page_name.search(searchTermRegex) !== -1 ||
            page_title.search(searchTermRegex) !== -1 ||
            page_description.search(searchTermRegex) !== -1
          );
        });
        if (filteredPages.length > 0) {
          setSearchResults(filteredPages);
          setNoSearchResults(false);
          setShowDefaultContainer(false);
        } else {
          setSearchResults("");
          setNoSearchResults(true);
          setShowDefaultContainer(false);
        }
      }
    };

    return (
      <>
        <SubNav
          data={subNavData}
          handleTabChange={handleTabChange}
          tab={selectedTab}
          handleSearch={handleSearch}
        />
        {searchResults.length !== 0 && (
          <ResultsContainer data={searchResults} />
        )}
        {noSearchResults && (
          <NoSearchResultContainer data={noSearchResultData} />
        )}
        <PagesList
          data={pagesListData}
          tab={selectedTab}
          wrapClassName={showDefaultContainer ? "" : "hide"}
        />
      </>
    );
  };
  return WrappedComponent;
}
